import { VStack } from "@chakra-ui/react"
import React from "react"
import { GenerateUserAttendanceReportForm } from "../../../forms"

export const GenerateUserAttendanceReport: React.FC = () => {
	return (
		<VStack w="full" spacing={6}>
			<GenerateUserAttendanceReportForm />
		</VStack>
	)
}
